<template>
  <Button
    :label="label"
    :icon="icon"
    :icon-pos="iconPos"
    :severity="severity"
    :loading="loading"
    :disabled="disabled"
    :rounded="rounded"
    :outlined="outlined"
    :text="text"
    :size="size"
    class="text-surface-btn"
    @click="handleClick"
  />
</template>

<script lang="ts">
export default defineComponent({
  props: {
    label: { type: String, default: "" },
    icon: { type: String, default: null },
    iconPos: { type: String, default: "left" },
    severity: { type: String, default: "primary" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    size: { type: String, default: null },
  },
  emits: ["click"],
  methods: {
    handleClick(event: Event) {
      this.$emit("click", event);
    },
  },
});
</script>

<style scoped>
.text-surface-btn {
  color: var(--surface-text, #222);

  &:hover {
    color: var(--surface-text, #222);
  }
}
</style>
